export interface LinkI {
    id: number
    name: string
    icon?: string
    icon_custom?: string
    url: string
    permissions: string[]
    not_permissions?: string[]
    sub_links: LinkI[]
    is_beta?: boolean
    isOther?: boolean
}

const DOCS_LINK: LinkI = {
    id: 200,
    name: 'Spark Docs',
    icon: 'fas fa-book',
    url: window.location.href.includes('bpms.spark.kz')
        ? 'https://docs-admin.spark.kz'
        : 'https://docs-admin.spark-dev.team',
    permissions: ['all-root-permission'],
    sub_links: [],
    isOther: true,
}

const GATEWAY_LINK: LinkI = {
    id: 1,
    name: 'Gateway',
    icon: 'fas fa-terminal',
    url: '/gateway',
    permissions: ['all-root-permission'],
    sub_links: [],
}

const USERS_LINK: LinkI = {
    id: 2,
    name: 'Пользователи',
    icon: 'fas fa-users',
    url: '/users',
    permissions: ['gateway-user-index', 'all-root-permission'],
    sub_links: [],
}

const HISTORY_LINK: LinkI = {
    id: 3,
    name: 'История заказов',
    icon: 'fas fa-bars',
    url: '/',
    permissions: ['admin-orders-index', 'all-root-permission'],
    sub_links: [],
}

const COMPANIES_LINK: LinkI = {
    id: 4,
    name: 'Компании',
    icon: 'fas fa-list-ul',
    url: '/companies',
    permissions: [],
    sub_links: [],
}

const DIRECTIONS_LINK: LinkI = {
    id: 5,
    name: 'Направления',
    icon: 'fas fa-route',
    url: '/directions',
    permissions: [],
    sub_links: [],
}

const CHANGES_HISTORY_LINK: LinkI = {
    id: 42,
    name: 'История изменений',
    icon: 'fas fa-history',
    url: '/changes-history',
    permissions: [],
    sub_links: [],
}

const CITIES_LINK: LinkI = {
    id: 6,
    name: 'Города',
    icon: 'fas fa-city',
    url: '/cities',
    permissions: [],
    sub_links: [],
}

const WAREHOUSES_LINK: LinkI = {
    id: 111,
    name: 'Склады',
    icon: 'fas fa-warehouse',
    url: '/warehouses',
    permissions: [],
    sub_links: [],
}

const PVZ_LINK: LinkI = {
    id: 7,
    name: 'ПВЗ',
    icon: 'fas fa-map-pin',
    url: '/pvz',
    permissions: ['pvz-distribution-centers-index', 'all-root-permission'],
    sub_links: [],
}

const CONTRACTS_LINK: LinkI = {
    id: 8,
    name: 'Договоры',
    icon: 'fas fa-file-signature',
    url: '/contracts',
    permissions: ['contract-contract-index', 'all-root-permission'],
    sub_links: [],
}

const DISPATCHER_LINK: LinkI = {
    id: 9,
    name: 'Диспетчерская',
    icon: 'fas fa-map-marked-alt',
    url: '/dispatcher',
    permissions: ['dispatcher-sectors-index', 'all-root-permission'],
    not_permissions: ['new-dispatcher'],
    sub_links: [],
}

const COURIERS_LINK: LinkI = {
    id: 10,
    name: 'Курьеры',
    icon: 'fas fa-truck',
    url: '/couriers',
    permissions: ['couriers-index'],
    sub_links: [],
}

const SCANS_LINK: LinkI = {
    id: 11,
    name: 'Сканы накладных',
    icon: 'fas fa-barcode',
    url: '/invoice-scans',
    permissions: ['order-logistic-info-index', 'all-root-permission'],
    sub_links: [],
}

const PRETENSIONS_LINK: LinkI = {
    id: 12,
    name: 'Претензии и Жалобы',
    icon: 'fas fa-exclamation',
    url: '/pretensions',
    permissions: ['cabinet-pretension-index', 'all-root-permission'],
    sub_links: [],
}

const SLA_LINK: LinkI = {
    id: 13,
    name: 'SLA клиента',
    icon: 'fas fa-tenge',
    url: '/sla',
    permissions: ['cabinet-sla-index', 'all-root-permission'],
    sub_links: [],
}

const BILLING_LINK: LinkI = {
    id: 14,
    name: 'Биллинг',
    icon: 'fas fa-tenge',
    url: '/billing',
    permissions: [],
    sub_links: [],
}

const RPP_LINK: LinkI = {
    id: 15,
    name: 'РПП',
    icon: 'fas fa-file',
    url: '/rpp/edit',
    permissions: ['payment_by_suppliers-index', 'all-root-permission'],
    sub_links: [],
}

const RPK_LINK: LinkI = {
    id: 16,
    name: 'РПК',
    icon: 'fas fa-file',
    url: '/rpk',
    permissions: ['cabinet-payment-by-couriers-index', 'all-root-permission'],
    sub_links: [],
}

const PAYMENT_REGISTRY_LINK: LinkI = {
    id: 17,
    name: 'Реестр платежей',
    icon: 'fas fa-file',
    url: '/rp',
    permissions: ['payment-list-index', 'all-root-permission'],
    sub_links: [],
}

const SURVEYS_LINK: LinkI = {
    id: 18,
    name: 'Опросы',
    icon: 'fas fa-chart-bar',
    url: '/surveys',
    permissions: ['admin-survey-index', 'all-root-permission'],
    sub_links: [],
}

const STORIES_LINK: LinkI = {
    id: 19,
    name: 'Истории МПП',
    icon: 'fas fa-image',
    url: '/stories',
    permissions: [],
    sub_links: [],
}

const VACANCIES_LINK: LinkI = {
    id: 20,
    name: 'Вакансии',
    icon: 'fas fa-address-card',
    url: '/vacancies',
    permissions: ['vacancy-feedback-index', 'all-root-permission'],
    sub_links: [],
}

const RESEND_ONE_C_LINK: LinkI = {
    id: 21,
    name: 'Переотправка заказов 1С',
    icon: 'fas fa-sync',
    url: '/one_c',
    permissions: ['cabinet-order-one-c', 'all-root-permission'],
    not_permissions: ['manager-permission'],
    sub_links: [],
}

const KPI_LINK: LinkI = {
    id: 22,
    name: 'КПИ',
    icon: 'fas fa-file',
    url: '/kpi',
    permissions: [],
    sub_links: [],
}

const COMMENTS_LINK: LinkI = {
    id: 33,
    name: 'Комментарии КЦ',
    icon: 'fas fa-comment',
    url: '/comments',
    permissions: [],
    sub_links: [],
}

const TARIFFS_LINK: LinkI = {
    id: 38,
    name: 'Тарифы',
    icon: 'fas fa-rocket',
    url: '/tariffs-express',
    permissions: [],
    sub_links: [],
}

const ACCOUNTANTS_LINKS: LinkI = {
    id: 1000,
    name: 'Бухгалтерия',
    icon: 'fas fa-calculator',
    url: '/',
    permissions: [],
    sub_links: [BILLING_LINK, RPP_LINK, RPK_LINK, PAYMENT_REGISTRY_LINK],
}

const MERCHANTS_LINKS: LinkI = {
    id: 1002,
    name: 'Мерчанты',
    icon: 'fas fa-users',
    url: '/merchants',
    permissions: [],
    sub_links: [],
}

const FLIGHT_DEPARTURES_LINKS: LinkI = {
    id: 1003,
    name: 'График вылетов',
    icon: 'fas fa-plane',
    url: '/flight-departures',
    permissions: [],
    sub_links: [],
}

const PROPOSAL_LINK: LinkI = {
    id: 23,
    name: 'Заявки',
    icon: 'fas fa-envelope',
    url: '/proposals',
    permissions: ['cabinet-proposal-index', 'all-root-permission'],
    sub_links: [],
}

const SETTINGS_LINK: LinkI = {
    id: 24,
    name: 'Настройки',
    icon: 'fas fa-cog',
    url: '/settings',
    permissions: ['cabinet-settings-index', 'all-root-permission'],
    sub_links: [],
}

const TMC_LINK: LinkI = {
    id: 25,
    name: 'ТМЦ',
    icon: 'fas fa-file',
    url: '/tmc',
    permissions: ['inventory-items-index', 'all-root-permission'],
    sub_links: [],
}

const SECURITY_LINK: LinkI = {
    id: 26,
    name: 'Проверка СБ',
    icon: 'fas fa-search',
    url: '/security-check',
    permissions: ['contract-adata-car-create-bid', 'all-root-permission'],
    sub_links: [],
}

const ARTICLES_LINK: LinkI = {
    id: 27,
    name: 'Блог Spark.kz',
    icon: 'fas fa-newspaper',
    url: '/blog',
    permissions: [],
    sub_links: [],
}

const CALLS_LINK: LinkI = {
    id: 34,
    name: 'История звонков',
    icon: 'fas fa-phone',
    url: '/calls',
    permissions: [],
    sub_links: [],
}

const CASES_LINK: LinkI = {
    id: 53,
    name: 'Кейсы',
    icon: 'fas fa-folder',
    url: '/cases',
    permissions: ['crm.cases-admin.index', 'all-root-permission'],
    sub_links: [],
}

const ADDITIONAL_LINKS: LinkI = {
    id: 1001,
    name: 'Дополнительно',
    icon: 'fas fa-star',
    url: '/',
    permissions: [],
    sub_links: [
        CASES_LINK,
        CHANGES_HISTORY_LINK,
        COMMENTS_LINK,
        TARIFFS_LINK,
        KPI_LINK,
        MERCHANTS_LINKS,
        FLIGHT_DEPARTURES_LINKS,
        SURVEYS_LINK,
        STORIES_LINK,
        VACANCIES_LINK,
        RESEND_ONE_C_LINK,
        TMC_LINK,
        SLA_LINK,
        ARTICLES_LINK,
        CALLS_LINK,
        SETTINGS_LINK,
        PROPOSAL_LINK,
        PVZ_LINK,
        CITIES_LINK,
        WAREHOUSES_LINK,
        DIRECTIONS_LINK,
    ],
}

const CREATE_ORDER_LINK: LinkI = {
    id: 28,
    name: 'Создать заказ',
    icon: 'fas fa-plus',
    url: '/order/create',
    permissions: [],
    sub_links: [],
}

const NEW_DISPATCHER_SECTORS_CONTROL: LinkI = {
    id: 29,
    name: 'Управление секторами',
    icon: 'fas fa-map-marked-alt',
    url: '/new-dispatcher/sectors-control',
    permissions: [
        'dispatcher.sector-index',
        'dispatcher.dispatcher-sectors-index',
        'all-root-permission',
    ],
    sub_links: [],
}

const NEW_DISPATCHER_COURIERS: LinkI = {
    id: 30,
    name: 'Курьеры',
    icon: 'fas fa-user-friends',
    url: '/new-dispatcher/couriers',
    permissions: ['dispatcher.courier-index', 'all-root-permission'],
    sub_links: [],
}

const NEW_DISPATCHER_CONTAINERS: LinkI = {
    id: 41,
    name: 'Контейнеры',
    icon: 'fas fa-box',
    url: '/new-dispatcher/containers',
    permissions: [],
    sub_links: [],
}

const NEW_DISPATCHER_TAKES: LinkI = {
    id: 31,
    name: 'Заборы',
    icon: 'fas fa-truck',
    url: '/new-dispatcher/takes',
    permissions: ['dispatcher.order-take-index', 'all-root-permission'],
    sub_links: [],
}

const NEW_DISPATCHER_MONITORING: LinkI = {
    id: 32,
    name: 'Мониторинг',
    icon: 'fas fa-desktop',
    url: '/new-dispatcher/monitoring',
    permissions: [],
    sub_links: [],
}

const NEW_DISPATCHER_FORECASTING: LinkI = {
    id: 43,
    name: 'Прогнозирование',
    icon: 'fas fa-box',
    url: '/new-dispatcher/forecasting',
    permissions: ['dispatcher.wave-index', 'all-root-permission'],
    sub_links: [],
}

const NEW_DISPATCHER_WORKPLACE: LinkI = {
    id: 54,
    name: 'Окно диспетчера',
    icon_custom: 'new_dispatcher_workplace.svg',
    url: '/dispatcher-workplace',
    permissions: [],
    sub_links: [],
}

const NEW_DISPATCHER_PLANNING: LinkI = {
    id: 35,
    name: 'Планирование',
    icon: 'fas fa-box',
    url: '/new-dispatcher/planning',
    permissions: ['dispatcher.planning-index', 'all-root-permission'],
    sub_links: [],
}

const NEW_DISPATCHER_COMPLETE_DAY: LinkI = {
    id: 36,
    name: 'Завершение дня',
    icon: 'fas fa-check',
    url: '/new-dispatcher/complete-day',
    permissions: ['dispatcher.courier-report', 'all-root-permission'],
    sub_links: [],
}

const NEW_DISPATCHER_ROUTE_SHEET: LinkI = {
    id: 37,
    name: 'Маршрутный лист',
    icon: 'fas fa-file-alt',
    url: '/new-dispatcher/route-sheet',
    permissions: ['dispatcher.route-sheet-index', 'all-root-permission'],
    sub_links: [],
}

const ARM_AMO_CRM: LinkI = {
    id: 47,
    name: 'AmoCRM',
    icon_custom: 'amo_crm.svg',
    url: '/amo-crm/customers',
    permissions: [],
    sub_links: [],
}

const ARM_WAIT_LIST: LinkI = {
    id: 48,
    name: 'Задания на обзвон',
    icon_custom: 'loader.svg',
    url: '/amo-crm/tasks',
    permissions: [],
    sub_links: [],
}

const ARM_WHATSAPP: LinkI = {
    id: 49,
    name: 'Whatsapp',
    icon: 'fas fa-comment',
    url: '/amo-crm/whatsapp',
    permissions: [],
    sub_links: [],
}

const NEW_DISPATCHER_DELIVERIES: LinkI = {
    id: 44,
    name: 'Доставки',
    icon: 'fas fa-cube',
    url: '/new-dispatcher/deliveries',
    permissions: ['dispatcher.delivery-index', 'all-root-permission'],
    sub_links: [],
}

const TMS_DIRECTIONS: LinkI = {
    id: 39,
    name: 'Направления',
    icon: 'fas fa-location-arrow',
    url: '/tms/directions',
    permissions: [],
    sub_links: [],
}

const TMS_INVENTORY: LinkI = {
    id: 40,
    name: 'Остатки',
    icon: 'fas fa-layer-group',
    url: '/inventory',
    permissions: [],
    sub_links: [],
}

const TMS_TRIPS: LinkI = {
    id: 45,
    name: 'Рейсы',
    icon: 'fas fa-route',
    url: '/tms/trips',
    permissions: ['tms.pre-trip-index'],
    sub_links: [],
}

const TMS_GRAPH: LinkI = {
    id: 46,
    name: 'График отправок',
    icon: 'fas fa-calendar',
    url: '/tms/graph',
    permissions: [],
    sub_links: [],
}

const TMS_COST_STANDARDS: LinkI = {
    id: 46,
    name: 'Нормы себестоимости',
    icon: 'fas fa-money-bill',
    url: '/tms/cost-standards',
    permissions: [],
    sub_links: [],
}

const TMS_WORKPLACE: LinkI = {
    id: 51,
    name: 'Рабочее окно логиста',
    url: '/tms/workplace',
    icon_custom: 'workplace.svg',
    permissions: [],
    sub_links: [],
}

const TMS_BIDS: LinkI = {
    id: 52,
    name: 'Заявки логиста',
    url: '/contracts/bids',
    icon_custom: 'bids.svg',
    permissions: [],
    sub_links: [],
}

const NEW_DISPATCHER_LINKS: LinkI = {
    id: 1002,
    name: 'Диспетчерская',
    icon: 'fas fa-map-marked-alt',
    url: '/',
    permissions: ['dispatcher.new', 'all-root-permission'],
    sub_links: [
        NEW_DISPATCHER_WORKPLACE,
        NEW_DISPATCHER_FORECASTING,
        NEW_DISPATCHER_PLANNING,
        NEW_DISPATCHER_MONITORING,
        NEW_DISPATCHER_COURIERS,
        NEW_DISPATCHER_CONTAINERS,
        NEW_DISPATCHER_SECTORS_CONTROL,
        NEW_DISPATCHER_DELIVERIES,
        NEW_DISPATCHER_TAKES,
        NEW_DISPATCHER_ROUTE_SHEET,
        NEW_DISPATCHER_COMPLETE_DAY,
    ],
}

const AMO_CRM_LINKS: LinkI = {
    id: 1005,
    name: 'АРМ Управление',
    icon: 'fas fa-headset',
    url: '/',
    permissions: [],
    not_permissions: ['manager-permission'],
    sub_links: [ARM_WAIT_LIST, ARM_AMO_CRM, ARM_WHATSAPP],
}

const CMS_INVOICES: LinkI = {
    id: 50,
    name: 'Накладные на сегодня',
    icon_custom: 'cms_invoices.svg',
    url: '/cms/invoices',
    permissions: ['cabinet.cms-invoices-index'],
    sub_links: [],
}

// const CMS_LINKS: LinkI = {
//     id: 1006,
//     name: 'CRM',
//     icon_custom: 'cms.svg',
//     url: '/',
//     permissions: [],
//     sub_links: [CMS_INVOICES],
// }

const TMS_LINKS: LinkI = {
    id: 1004,
    name: 'TMS',
    icon: 'fas fa-compass',
    url: '/',
    permissions: ['tms.direction-index'],
    sub_links: [TMS_WORKPLACE, TMS_DIRECTIONS, TMS_BIDS, TMS_TRIPS, TMS_GRAPH, TMS_COST_STANDARDS],
}

export const LINKS: LinkI[] = [
    DOCS_LINK,
    CREATE_ORDER_LINK,
    GATEWAY_LINK,
    HISTORY_LINK,
    CMS_INVOICES,
    USERS_LINK,
    COMPANIES_LINK,
    CONTRACTS_LINK,
    // DISPATCHER_LINK,
    COURIERS_LINK,
    SCANS_LINK,
    PRETENSIONS_LINK,
    AMO_CRM_LINKS,
    NEW_DISPATCHER_LINKS,
    TMS_INVENTORY,
    TMS_LINKS,
    ACCOUNTANTS_LINKS,
    ADDITIONAL_LINKS,
    SECURITY_LINK,
]
